﻿(function () {
    'use strict';

    var serviceId = 'repository.appmntCtainerEntrySearch';

    angular
        .module('app.services')
        .factory(serviceId, appmntCtainerEntrySearch);

    appmntCtainerEntrySearch.$inject = ['common', 'repository.abstract'];
   
    function appmntCtainerEntrySearch(common, abstractRepository) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            
            this.myFunction = myFunction;
        }
        abstractRepository.extend(Ctor);

        return Ctor;
        
        function myFunction() {
            
        }

    }
})();